import Vue from 'vue'

export default async () => {
  const res = await Vue.axios.get(`/billing/plans?product_category=wanip&interval_count=1`)
  return res.data
}



// WEBPACK FOOTER //
// ./src/services/billing/fetch-ip.js